import {CircularProgress, TableRow} from '@material-ui/core';
import React, {CSSProperties} from 'react';
import 'Shared/components/PagedView/Table/TableLoadingRow.sass';

type LoadingRowProps = {
  style: CSSProperties;
};

const LoadingRow = (props: LoadingRowProps) => (
  <TableRow style={props.style} className="loading-row" component="div"  aria-busy="true">
    Loading Additional Results...&nbsp;
    <CircularProgress aria-label="Loading Additional Results"/>
  </TableRow>
);

export default LoadingRow;
